export default "__VITE_ASSET__ea3ed3ba__"